export type LeaderboardPlayer = {
  firstName: string
  profit: number
  photoUrl: string
  own?: boolean
  isPremium: boolean
}

export type EffortLeaderboardPlayer = {
  firstName: string
  score: number
  photoUrl: string
  isThisPlayer: boolean
  isPremium: boolean
}

export type CardChallengeLeaderboardPlayer = {
  firstName: string
  score?: number
  photoUrl: string
  isThisPlayer?: boolean
}

export enum CardChallengeType {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  ALL_TIME = 'allTime'
}

export enum ChallengeMedal {
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze'
}
